import styled from '@emotion/styled';

import { Dialog, IconButton } from '@mui/material';

export const Wrapper = styled.div`
  position: relative;
`;

export const CloseIconButton = styled(IconButton)`
  position: absolute;
  top: ${p => p.theme.spacing(2)};
  right: ${p => p.theme.spacing(2)};
  border: none;
  padding: ${p => p.theme.spacing(0.3)};

  svg {
    width: ${p => p.theme.spacing(3)};
    height: ${p => p.theme.spacing(3)};
  }
`;

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    border: 1px solid ${p => p.theme.palette.primary.main};
    padding: ${p => p.theme.spacing(4, 5)};
    max-width: 1000px;
  }

  .MuiDialogContent-root {
    padding: 0;
  }

  .MuiDialogTitle-root {
    font-weight: 40;
    font-size: ${p => p.theme.typography.h2.fontSize};

    padding: 0;
    margin-bottom: ${p => p.theme.spacing(2)};
  }

  .MuiDialogActions-root {
    margin-top: ${p => p.theme.spacing(4)};
    gap: ${p => p.theme.spacing(2)};
    padding: 0;
  }
`;
